import controller from './thing-owner.controller';

const template = require('./thing-owner.html');

export default {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-owner/thing-owner.component.js